var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.33333H15.75V7.80952C15.75 5.70667 14.07 4 12 4C9.93 4 8.25 5.70667 8.25 7.80952V9.33333H7.5C6.675 9.33333 6 10.019 6 10.8571V18.4762C6 19.3143 6.675 20 7.5 20H16.5C17.325 20 18 19.3143 18 18.4762V10.8571C18 10.019 17.325 9.33333 16.5 9.33333ZM12 16.1905C11.175 16.1905 10.5 15.5048 10.5 14.6667C10.5 13.8286 11.175 13.1429 12 13.1429C12.825 13.1429 13.5 13.8286 13.5 14.6667C13.5 15.5048 12.825 16.1905 12 16.1905ZM14.325 9.33333H9.675V7.80952C9.675 6.50667 10.7175 5.44762 12 5.44762C13.2825 5.44762 14.325 6.50667 14.325 7.80952V9.33333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon_password.f92c35331db9f9b5ed8f3b63e8a708c8.svg";
export { ForwardRef as ReactComponent };